import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=bb38ff42&"
import script from "./Companies.vue?vue&type=script&lang=ts&"
export * from "./Companies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb38ff42')) {
      api.createRecord('bb38ff42', component.options)
    } else {
      api.reload('bb38ff42', component.options)
    }
    module.hot.accept("./Companies.vue?vue&type=template&id=bb38ff42&", function () {
      api.rerender('bb38ff42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics/Companies.vue"
export default component.exports